import NegativeFeedbackComment from '@/components/buttons/NegativeFeedbackComment.vue';
import NegativeProxy from '@/proxies/Negative/NegativeProxy';

export default {
  components: {
    NegativeFeedbackComment,
  },
  methods: {
    negativeFeedbackClick() {
      if (this.item.negative) {
        this.$router.push({
          name: 'negatives.show',
          params: { negativeUuid: this.item.negative },
        });
      } else {
        new NegativeProxy().create({
          negatable_uuid: this.item.uuid,
          negatable_type: this.negatableType,
        })
          .then((response) => {
            this.$router.push({
              name: 'negatives.show',
              params: { negativeUuid: response.data.data.negative.uuid },
            });
          })
          .catch((error) => {
            console.warn(error);
            this.$store.dispatch('page/displaySnackbar', {
              text: 'Ошибка',
              color: 'red darken-3',
              timeout: 6000,
            });
          })
          .finally(() => {
          });
      }
    },
  },
};
